<template>
  <b-container class="p-main-container">


    <div class="p-buttons-wrap">
      <!-- <b-btn @click="hideModal">Close Me</b-btn> -->
      <b-button variant="info" @click="print">Print Profile</b-button>
      <b-button variant="info" @click="edit">Edit Profile</b-button>

      <!-- <button v-print="'#printMe'">Print Application</button> -->
    </div>

    <div id="printme">
      <div class="application-view">
        <!-- Print Header -->
        <div class="print-header">
          <div class="header-logos">
            <img src="../../assets/images/satyamev-jayate.png" alt="Emblem" class="header-logo-left">
            <img src="../../assets/images/header4.png" alt="Logo" class="header-logo-center">
            <img src="../../assets/images/top_image2.png" alt="Logo" class="header-logo-right">
          </div>
          <div class="header-text">
            <h3 class="header-title-marathi">ब्रम्हलिन आचार्य दिव्यानंद पूरीजी महाराज आर्थिक विकास महामंडळ</h3>
            <h4 class="header-title-english">Vasantrao Naik Vimukta Jaties and Nomedic Tribes Development Corporation (LTD.)</h4>
            <p class="header-subtitle">इतर मागास बहुजन कल्याण विभाग</p>
          </div>
        </div>

        <div class="reg-form-box">
          <div class="reg-form-body">
            <b-container class="bv-example-row" fluid>
              <div class="header-with-photo">
                <div class="header-content">
                  <h5 class="reg-form-title text-primary">Application No: {{personalDetails.LoanApplication[0].LoanApplicationNo}}</h5>
                </div>
                <div class="photo-container">
                  <img
                    class="applicant-photo"
                    :src="getImgUrl(personalDetails.UserLoanDocuments.PhotoPath)"
                  >
                </div>
              </div>
              <b-row>
                <b-col cols="12">
                  <h5 class="reg-form-title text-primary">Personal Details</h5>
                  <table class="profile-table table-3x" style="margin-left:0">
                      <tbody>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Applicant Name:</span>
                            {{personalDetails.FirstName}} {{personalDetails.MiddleName}} {{personalDetails.LastName}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Date Of Birth:</span>
                            {{personalDetails.DOB}}
                          </td>
                          <td>
                            <span class="bold">Aadhar Id:</span>
                            {{personalDetails.AdharNo}}
                          </td>
                          <td>
                            <span class="bold">PAN No.:</span>
                            {{personalDetails.PanCardNo}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Gender:</span>
                            <span v-if="personalDetails.Gender">Male</span>
                            <span v-else>Female</span>
                          </td>
                          <td>
                            <span class="bold">Email:</span>
                            {{personalDetails.EmailID}}
                          </td>
                          <td>
                            <span class="bold">Mobile No.:</span>
                            {{personalDetails.MobileNo}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Married Status:</span>
                            <span v-if="personalDetails.MaritalStatus">Yes</span>
                            <span v-else>No</span>
                          </td>
                          <td>
                            <span class="bold">Nationality:</span>
                            <span v-if="personalDetails.Nationality">Indian</span>
                            <span v-else>Non-Indian</span>
                          </td>
                          <td>
                            <span class="bold">Maharashtra Domicile:</span>
                            <span v-if="personalDetails.Domiciled">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Ration Card:</span>
                            <span>{{personalDetails.RationCardNo}}</span>
                          </td>
                          <td>
                            <span class="bold">Family Income:</span>
                            <span>{{personalDetails.FamilyIncome}}</span>
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Caste:</span>
                            <span>{{personalDetails.CasteName}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>

      <!-- ******** -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row" fluid>
            <b-row>
              <b-col cols="12">
                <h5 class="reg-form-title text-primary">Address Details</h5>
                <table class="profile-table table-3x" style="margin-left:0">
                    <tbody>
                      <tr>
                        <td><span class="bold">House No: </span>{{personalDetails.CorrespondenceAddress.HouseNo}}</td>
                        <td><span class="bold">Building No: </span>{{personalDetails.CorrespondenceAddress.BuildingNo}}</td>
                        <td><span class="bold">Landmark: </span>{{personalDetails.CorrespondenceAddress.Landmark}}</td>
                      </tr>
                      <tr>
                        <td><span class="bold">Village: </span>{{personalDetails.CorrespondenceAddress.Village}}</td>
                        <td><span class="bold">Taluka: </span>{{personalDetails.CorrespondenceAddress.TalukaName}}</td>
                        <td><span class="bold">District: </span>{{personalDetails.CorrespondenceAddress.DistrictName}}</td>

                      </tr>
                      <tr>
                        <td><span class="bold">Post: </span>{{personalDetails.CorrespondenceAddress.Post}}</td>
                        <td><span class="bold">State: </span>{{personalDetails.CorrespondenceAddress.StateName}}</td>
                        <td><span class="bold">Pincode: </span>{{personalDetails.CorrespondenceAddress.Pincode}}</td>

                      </tr>
                    </tbody>
                  </table>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- family details starts here -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row" fluid>
            <b-row>
              <b-col cols="12">
                <h5 class="reg-form-title text-primary">Family Details</h5>
                <table class="profile-table info-table" style="margin-left:0">
                    <tbody>
                      <tr>
                        <th class="bold">Full Name</th>
                        <th class="bold">Gender</th>
                        <!-- <th class="bold">Date of Birth</th> -->
                        <th class="bold">Age (Yrs)</th>
                        <th class="bold">Relation Ship</th>
                      </tr>
                      <tr v-for="member in personalDetails.UserFamily" :key="member">
                        <td>{{member.FullName}}</td>
                        <td v-if="member.Gender">Male</td>
                        <td v-else>Female</td>
                        <!-- <td>{{member.DOBstr}}</td> -->
                        <td>{{member.Age}}</td>
                        <td>{{member.ReletionshipName}}</td>
                      </tr>
                    </tbody>
                  </table>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- family details ends here -->

      <!-- <div class="reg-form-box" style="">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Details</h5>

                  <table class="profile-table">
                    <tbody>
                      <tr>
                        <td><span class="bold">Bank Accept: </span>{{personalDetails.UserBankDetails.BankAccept}}</td>
                        <td><span class="bold">Bank Name: </span>{{personalDetails.UserBankDetails.BankName}}</td>
                        <td><span class="bold">Branch Name: </span>{{personalDetails.UserBankDetails.BranchName}}</td>
                      </tr>
                      <tr>
                        <td><span class="bold">City: </span>{{personalDetails.UserBankDetails.City}}</td>
                        <td><span class="bold">Comment: </span>{{personalDetails.UserBankDetails.Comment}}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>

            </b-row>
          </b-container>
        </div>
      </div> -->

      <!-- bank account start here -->
      <div class="reg-form-box" style="">
        <div class="reg-form-body">
          <b-container class="bv-example-row" fluid>
            <b-row>
              <b-col cols="12">
                <h5 class="reg-form-title text-primary">Bank Account</h5>
                <table class="profile-table" style="margin-left:0">
                    <tbody>
                      <tr>
                        <td><span class="bold">Bank Account No: </span>{{personalDetails.UserBankAccount.BankAccountNo}}</td>
                        <td><span class="bold">Bank IFSC Code: </span>{{personalDetails.UserBankAccount.BankIfscCode}}</td>
                        <td><span class="bold">Bank Name: </span>{{personalDetails.UserBankAccount.BankName}}</td>
                      </tr>
                      <tr>
                        <td><span class="bold">Branch Name: </span>{{personalDetails.UserBankAccount.BranchName}}</td>
                        <td><span class="bold">City: </span>{{personalDetails.UserBankAccount.City}}</td>

                      </tr>
                    </tbody>
                  </table>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>


      <!-- bank account ends here -->
      <div class="reg-form-box" style="">
        <div class="reg-form-body">
          <b-container class="bv-example-row" fluid>
              <b-row>
                <b-col cols="12">
                  <h5 class="reg-form-title text-primary">Lending Loan Details 4</h5>
                  <table class="profile-table" style="margin-left:0">
                      <tbody>
                        <tr>
                          <td><span class="bold">Organization Name: </span>{{personalDetails.UserLendingLoanDetails.OrganizationName}}</td>
                          <td><span class="bold">Organization Address: </span>{{personalDetails.UserLendingLoanDetails.OrganizationAddress}}</td>
                        </tr>
                        <tr>
                          <td><span class="bold">Product From Organization: </span>{{personalDetails.UserLendingLoanDetails.ProductfromOrganization}}</td>
                          <td><span class="bold">Amount From Bank: </span>{{personalDetails.UserLendingLoanDetails.AmountFromBank}}</td>
                        </tr>
                        <tr>
                          <td><span class="bold">Bank Name: </span>{{personalDetails.UserLendingLoanDetails.BankName}}</td>
                          <td><span class="bold">Branch: </span>{{personalDetails.UserLendingLoanDetails.Branch}}</td>
                        </tr>
                      </tbody>
                    </table>
                </b-col>
              </b-row>
          </b-container>
        </div>
      </div>

      <div class="reg-form-box" style="">

        <div class="reg-form-body">

          <b-container class="bv-example-row" fluid>
              <b-row>

                <b-col cols="12">
                  <h5 class="reg-form-title text-primary">Documents Uploaded</h5>
                  <table class="profile-table doc-table" style="margin-left:0">
                        <tr>
                          <th>Sr No</th>
                          <th>Document Type</th>
                          <th>Value</th>
                          <th>Link</th>

                        </tr>
                        <tr>
                            <td>01.</td>
                          <td>Photo</td>
                          <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.PhotoPath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.PhotoPath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.PhotoPath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>02.</td>
                            <td>Birth Certificate</td>
                            <td>{{personalDetails.DOB}}</td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.BirthCertificate ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.BirthCertificate !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.BirthCertificate)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>03.</td>
                            <td>Caste Certificate</td>
                            <td>{{personalDetails.CasteName}}</td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.CastCertificate ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.CastCertificate !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.CastCertificate)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>04.</td>
                            <td>Income Certificate</td>
                            <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.IncomeCertificatePath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.IncomeCertificatePath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.IncomeCertificatePath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>05.</td>
                            <td>Domicile Certificate</td>
                            <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.DomicileCertificate ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.DomicileCertificate !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.DomicileCertificate)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>06.</td>
                            <td>Residential Proof</td>
                            <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.ResidentialProofPath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.ResidentialProofPath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.ResidentialProofPath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>07.</td>
                            <td>Aadhaar Card</td>
                            <td>{{personalDetails.AdharNo}}</td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.AddharCardPath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.AddharCardPath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.AddharCardPath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>08.</td>
                            <td>Aadhaar Card(Back)</td>
                            <td>
                            </td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.AddharCardBackPath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.AddharCardBackPath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.AddharCardBackPath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>09.</td>
                            <td>Ration Card</td>
                            <td>{{personalDetails.RationCardNo}}</td>
                            <td>

                              <span v-if="personalDetails.UserLoanDocuments.RationCardPath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.RationCardPath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.RationCardPath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>10.</td>
                            <td>Ration Card Last Page</td>
                            <td>{{personalDetails.RationCardNo}}</td>
                            <td>

                              <span v-if="personalDetails.UserLoanDocuments.RationCardLastPath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.RationCardLastPath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.RationCardLastPath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>11.</td>
                            <td>Pan Card</td>
                            <td>{{personalDetails.PanCardNo}}</td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.PancardPath ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.PancardPath !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.PancardPath)">View</a>
                              </span>
                            </td>
                        </tr>

                        <tr>
                            <td>12.</td>
                            <td>Bank Account Proof</td>
                            <td>{{personalDetails.UserBankAccount.BankAccountNo}}</td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.BankAccount ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.BankAccount !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.BankAccount)">View</a>
                              </span>
                            </td>
                        </tr>
                        <tr>
                            <td>13.</td>
                            <td>Other Documents</td>
                            <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.OtherDocument ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.OtherDocument !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.OtherDocument)">View</a>
                              </span>
                            </td>
                        </tr>
                        <tr v-if="personalDetails.UserLoanDocuments.Other2 !=''">
                            <td>14.</td>
                            <td>{{personalDetails.UserLoanDocuments.Other2Name}}</td>
                            <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.Other2 ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.Other2 !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.Other2)">View</a>
                              </span>
                            </td>
                        </tr>
                        <tr v-if="personalDetails.UserLoanDocuments.Other3 !=''">
                            <td>15.</td>
                            <td>{{personalDetails.UserLoanDocuments.Other3Name}}</td>
                            <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.Other3 ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.Other3 !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.Other3)">View</a>
                              </span>
                            </td>
                        </tr>
                        <tr v-if="personalDetails.UserLoanDocuments.Other4 !=''">
                            <td>16.</td>
                            <td>{{personalDetails.UserLoanDocuments.Other4Name}}</td>
                            <td></td>
                            <td>
                              <span v-if="personalDetails.UserLoanDocuments.Other4 ==''">Not Uploaded</span>
                              <span v-if="personalDetails.UserLoanDocuments.Other4 !=''">
                                <a target="_blank" :href="getImgUrl(personalDetails.UserLoanDocuments.Other4)">View</a>
                              </span>
                            </td>
                        </tr>

                    </table>
                </b-col>
              </b-row>
          </b-container>


        </div>
      </div>

    </div> <!-- Printme id ends here -->

  </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
import Formatter from "@/Formatter.js";
export default {
  data() {
    return {
      personalDetails: {
        UserID: null,
        Salutation: null,
        FullName: null,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: "",
        Age: 38,
        PlaceOfBirth: "",
        Gender: true,
        MotherName: "",
        MobileNo: "",
        MobileNo1: null,
        LandlineNo: null,
        MaritalStatus: true,
        MotherToungue: true,
        EmailID: "",
        Nationality: true,
        Domiciled: true,
        MotherToung: "Hindi",
        AdharNo: "",
        PanCardNo: "",
        CategoryType: null,
        BoardID: "a1bfdfd8-db30-4d39-87f7-5f2eddd7f810",
        RegistrationType: 2,
        CasteName: "",
        FamilyIncome: 0,
        RationCardNo: "",
        LoginID: "00000000-0000-0000-0000-000000000000",
        ApplicationID: null,
        TotalMarks: 0,
        ResultStatus: null,
        ExServiceMan: false,
        Driving: true,
        JobID: null,
        DeceasedRegNum: null,
        DeceasedName: null,
        DeceasedRelation: null,
        OtherRelationName: "",
        OrderNum: null,
        OrderDate: "2001-01-01T00:00:00",
        CourtName: null,
        PetitionNum: null,
        PetitionDate: "2001-01-01T00:00:00",
        UnionName: null,
        LockProfile: true,
        RegistrationTypeName: "",
        BoardName: "",
        PermanentAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 400612,
          Post: "",
          StateName: "",
          DistrictName: "",
          TalukaName: ""
        },

        CorrespondenceAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 0,
          Post: "",
          ResidanceSince: 1,
          StateName: "Maharashtra",
          DistrictName: "Thane",
          TalukaName: "Thane"
        },
        UserBankDetails: {
          BankAccept: true,
          BankID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          BankName: "",
          BranchName: "",
          City: "",
          Comment: ""
        },
        UserLendingLoanDetails: {
          AmountFromBank: "",
          LoanDistrict: "",
          OrganizationAddress: "",
          OrganizationName: "",
          ProductfromOrganization: "",
          UserLendingLoanID: ""
        },
        UserPhysicalDetails: {
          UserPhysicalID: null,
          IndetificationMark: "",
          Height: 188,
          Weight: 85,
          ChestDeflated: 100,
          ChestInflated: 105
        },
        UserQualification: {
          QualificationTypeID: "09713307-253d-4e35-aca9-50ccde3e05a6",
          DegreeID: "03c001dc-b65e-4b96-bd25-f4e425c7fab6",
          StateID: "6e394345-c136-4618-9258-d3bd530fd97b",
          BoardID: "80d06c9d-8256-4b83-ad87-620debf38d32",
          Result: 1,
          Percentage: 66.0,
          Class: "First Class",
          QualificationType: {
            QualificationTypeID: null,
            QualificationTypeName: "Graduate"
          },
          DegreeType: {
            DegreeTypeID: null,
            DegreeName: "B.A.",
            QaulificaitonTypeID: "00000000-0000-0000-0000-000000000000"
          },
          UserState: {
            StateID: "00000000-0000-0000-0000-000000000000",
            StateName: "Bihar"
          },
          EducationBoard: {
            BoardID: null,
            BoardName: "",
            InstituteType: null,
            StateID: "00000000-0000-0000-0000-000000000000"
          }
        },
        UserLoanDocuments: {
          PhotoPath: null,
          AddharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CastCertificate: null,
          BirthCertificate: null,
          ResidentialProofPath: null,
          DomicileCertificate: null,
          IncomeCertificatePath: null,
          OtherDocument: null
        },
        UserDocuments: {
          PhotoPath: null,
          SignaturePath: null,
          AddharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CasteCertificate: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          BirthCertificate: null,
          PoliceVerification: null,
          MedicalCertificate: null,
          RecommendationLetter: null,
          DeceasedID: null,
          LegalHireNOC: null,
          FinalDuesLetter: null,
          CourtOrder: null
        },
        UserEmergencyContact: {
          ContactName: "",
          Address: "",
          MobileNo: ""
        },
        UserOtherDetails: {
          WorkingYears: "",
          EmployerName: "",
          LoadCapcity: "",
          UnionName: "",
          AccidentHistory: "",
          MedicallyFit: "",
          CriminalCase: "",
          ToliName: "",
          ToliNumber: ""
        },
        UserReligionCaste: {
          ReligionID: "d3f6b84b-c005-474d-aff9-dd27fa763ebc",
          CategoryID: "d25679fb-92ea-434d-a0f8-65b3290c7a8b",
          ReligionName: null,
          CategoryType: null,
          SubCaste: ""
        },
        UserEmploymentExchange: {
          EmploymentName: null,
          EmploymentRegNo: null,
          EmploymentExchangeStatus: false
        },
        UserDecleration: {
          UserID: "00000000-0000-0000-0000-000000000000",
          ConfirmStatus: false,
          DeclerationText: null
        },
        ApplyForJob: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          JobId: "00000000-0000-0000-0000-000000000000",
          UserID: "00000000-0000-0000-0000-000000000000",
          Status: 0,
          PersonalDetail: false,
          AddressDetail: false,
          OtherDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          ApplicationNo: null
        },
        UserApplication: [],
        UserEvaluation: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          BatchID: "00000000-0000-0000-0000-000000000000",
          RunningMark: 0,
          PullUps: 0,
          Situps: 0,
          EducationalMarks: 0,
          Height: 0,
          Weight: 0,
          ChestDeflated: 0,
          ChestInflated: 0
        },
        UserDocumentReview: {
          Review: false,
          Comments: null,
          ApplicationID: "00000000-0000-0000-0000-000000000000"
        },
        UserDocumentUpload: {
          ApplicantPhotoStatus: false,
          ApplicantSignatureStatus: false,
          AdharCardStatus: false,
          RationCardStatus: false,
          DOBCertificateStatus: false,
          CasteCertificateStatus: false,
          DegreeCertificateStatus: false,
          ExprienceCertificateStatus: false,
          ExServiceManCertificateStatus: false
        },
        UserDocuments: {
          PhotoPath: "",
          SignaturePath: "",
          AddharCardPath: "",
          PancardPath: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: ""
        },
        UserNominee: [
          {
            NomineeID: "2ff23306-0f82-4613-8197-1aff4533d8b1",
            NomineeName: "",
            Gender: false,
            DOB: "",
            ReletionShip: 3,
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          }
        ],
        UserProfileStatus: {
          PersonalDetail: false,
          AddressDetail: false,
          PhysicalDetail: false,
          NomineeDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          FamilyDetail: false
        },
        LoanApplication: [
          {
            LoanType: "",
            UserID: "",
            LoanApplicationID: "",
            LoanApplicationNo: "",
            SchemeType: "",
            GroupID: "",
            AmountDemanded: "",
            ApplicationStatus: "",
            AmountApproved: "",
            Level1Approver: "",
            Level1ApprovalDate: "",
            Level2Approver: "",
            Level2ApprovalDate: "",
            LOIDate: "",
            BankID: "",
            BankApprovalDate: "",
            BankLoanAmount: "",
            BankInterestRate: "",
            LoanTenure: "",
            LoanStartDate: "",
            LoanEndDate: "",
            LoanStatus: ""
          }
        ],
        UserBankAccount: {
          BankAccountNo: "",
          BankIfscCode: "",
          BankName: "",
          BranchName: "",
          City: ""
        },
        UserFamily: [
          {
            FamilyID: "efc2815c-68ef-4211-b804-2dde92d97522",
            FullName: "",
            Gender: false,
            DOB: "",
            ReletionShipID: "6fce0f55-2fb6-45b3-ad1f-aa6eb9cecae7",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          },
          {
            FamilyID: "026e72ee-55b9-4fd4-8a58-3e0f96a08ed4",
            FullName: "",
            Gender: true,
            DOB: "2014-06-03T00:00:00",
            ReletionShipID: "435ea13a-01f6-4360-aa7c-eabb5e4a791a",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          },
          {
            FamilyID: "413f61a2-1b95-49b9-b397-8cc53994f134",
            FullName: "",
            Gender: false,
            DOB: "1983-12-24T00:00:00",
            ReletionShipID: "f57b429f-481e-47f3-a6dd-99acc6456b56",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          }
        ]
      },
      docObj: {},
      docTbl: []
    };
  },
  methods: {
    print() {
      window.print();
      //this.$htmlToPaper("printme");
    },
    edit() {
      debugger;
      this.$router.push("/LoginProfile");
    },

    getImgUrl(pic) {
      let userinfo = this.$store.getters.loggedUser;
      let userId = userinfo.UserId;
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" + userId + "/" + pic
        );
      }
    }
  },

  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    let promiseU = apis.ReadUserDetailByIndivisual(userinfo.UserId); //Personal Details

    promiseU
      .then(response => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body;
          this.personalDetails.DOB = Formatter.convertDateFormatYMD(
            response.body.DOB
          );
          this.personalDetails.UserLoanDocuments =
            response.body.UserLoanDocuments;
          for (var i = 0; i < response.body.LoanApplication.length; i++) {
            if (response.body.LoanApplication[i].LoanType == 1) {
              this.personalDetails.LoanApplication[0].LoanApplicationNo =
                response.body.LoanApplication[i].LoanApplicationNo;
            }
          }
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>
<style>
.p-main-container {
  padding-top: 30px;
  background-color: #fff;
  padding-bottom: 30px;
}

.p-buttons-wrap {
  width: fit-content;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 30px;
}

.p-buttons-wrap button {
  color: #fff;
  background-color: #0A0032;
  font-size: 13px;
  font-weight: bold;
  border: none;
  padding: 8px 20px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
}

.p-buttons-wrap button.btn-info:hover,
.p-buttons-wrap button.btn-info:active,
.p-buttons-wrap button.btn-info:visited,
.p-buttons-wrap button.btn-info:focus {
  background-color: #0A0032 !important;
  color: #fff !important;
  border: none !important;
  outline: none !important;
}

.text-primary {
  font-size: 18px;
  color: #000 !important;
  margin-bottom: 20px;
  font-weight: bold;
}

table.profile-table {
  border: 0px solid #d3d3d3;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}
table.profile-table td,
table.profile-table th {
  border: 1px solid #d3d3d3;
  padding: 8px 15px;
}

table.table-3x td,
table.table-3x th {
  width: 33%;
}
table.profile-table td span.bold {
  font-weight: bold;
  font-size: 14px;
}

.bold {
  font-weight: bold;
  font-size: 14;
  color: #000;
}

table.profile-table tbody td {
  font-size: 13px;
  color: #000000;
}

table.doc-table {
  width: 50%;
}

.reg-form-box .reg-form-body {
  border: none;
  padding-top: 10px;
  padding-bottom: 0;
}

.header-with-photo {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  min-height: 150px;
}

.header-content {
  padding-right: 140px;
}

.photo-container {
  position: absolute;
  top: 0;
  right: 15px;
  width: 120px;
}

.applicant-photo {
  width: 120px;
  height: 140px;
  object-fit: cover;
  border: 2px solid #d3d3d3;
  border-radius: 4px;
  display: block;
}

/* Print Header Styles */
.print-header {
  display: none;
  text-align: center;
  padding: 10px 0;
  border-bottom: 2px solid #000;
  margin-bottom: 15px;
  background: #fff;
}

.header-logos {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 30px;
}

.header-logo-left,
.header-logo-center,
.header-logo-right {
  height: 60px;
  width: auto;
  object-fit: contain;
}

.header-logo-left {
  max-width: 60px;
}

.header-logo-center {
  max-width: 80px;
}

.header-logo-right {
  max-width: 60px;
}

.header-text {
  margin: 8px 0;
  line-height: 1.4;
}

.header-title-marathi {
  color: royalblue;
  font-size: 18px;
  font-weight: bold;
  margin: 5px 0;
  line-height: 1.3;
}

.header-title-english {
  color: #000;
  font-size: 12px;
  font-weight: normal;
  margin: 3px 0;
  line-height: 1.2;
}

.header-subtitle {
  color: royalblue;
  font-size: 12px;
  margin: 3px 0;
  font-weight: normal;
  line-height: 1.2;
}

@media print {
  /* Reset responsive styles for print */
  * {
    box-sizing: border-box;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  html, body {
    width: 210mm !important;
    height: auto;
    margin: 0;
    padding: 0;
    background: #fff;
    font-size: 12px !important;
  }

  /* Force all content to use desktop layout regardless of device */
  body {
    min-width: 100% !important;
    max-width: 100% !important;
  }

  /* Override all responsive breakpoints */
  @media (max-width: 768px) {
    body {
      width: 210mm !important;
    }
  }

  /* Show print header */
  .print-header {
    display: block !important;
    page-break-after: avoid !important;
    page-break-inside: avoid !important;
    width: 100% !important;
  }

  .header-logos {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
  }

  .header-logos img {
    max-height: 60px !important;
    width: auto !important;
    display: block !important;
  }

  /* Hide portal header and unwanted elements */
  .top-nav-bar,
  .p-buttons-wrap,
  button,
  .btn,
  nav,
  .navbar,
  .goog-te-banner-frame,
  .goog-te-gadget,
  .skiptranslate,
  #google_translate_element,
  #top-nav-header,
  .VPT,
  .mobile-menu,
  .hamburger,
  a[href]:after {
    display: none !important;
    visibility: hidden !important;
  }

  /* Ensure printme div is visible */
  #printme {
    position: relative !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    visibility: visible !important;
    display: block !important;
  }

  #printme * {
    visibility: visible !important;
  }

  /* Full width container for print - override mobile styles */
  .container,
  .container-fluid,
  .b-container,
  .p-main-container {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin: 0 !important;
    padding: 10px !important;
    display: block !important;
  }

  /* Reset row and column styles */
  .row,
  .b-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: block !important;
    width: 100% !important;
    flex-wrap: nowrap !important;
  }

  .col,
  [class*="col-"],
  .b-col {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin: 0 !important;
    float: none !important;
    display: block !important;
    flex: none !important;
  }

  /* Override mobile column widths */
  .col-6, .col-sm-6, .col-md-6, .col-lg-6,
  .col-4, .col-sm-4, .col-md-4, .col-lg-4,
  .col-3, .col-sm-3, .col-md-3, .col-lg-3 {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Header with photo - works on all devices */
  .header-with-photo {
    position: relative !important;
    width: 100% !important;
    margin-bottom: 15px !important;
    min-height: 145px !important;
    display: block !important;
  }

  .header-content {
    padding-right: 130px !important;
    width: 100% !important;
    display: block !important;
  }

  .photo-container {
    position: absolute !important;
    top: 0 !important;
    right: 10px !important;
    width: 110px !important;
    display: block !important;
  }

  .applicant-photo {
    width: 110px !important;
    height: 130px !important;
    object-fit: cover !important;
    border: 1px solid #000 !important;
    display: block !important;
  }

  /* Table styling for print */
  table.profile-table {
    width: 100% !important;
    border-collapse: collapse !important;
    page-break-inside: auto !important;
    margin-bottom: 15px !important;
  }

  table.profile-table tr {
    page-break-inside: avoid !important;
    page-break-after: auto !important;
  }

  table.profile-table td,
  table.profile-table th {
    border: 1px solid #000 !important;
    padding: 6px 8px !important;
    font-size: 11px !important;
    color: #000 !important;
    line-height: 1.3 !important;
  }

  table.profile-table td span.bold {
    font-weight: bold !important;
    color: #000 !important;
  }

  /* Hide View links in print */
  table.profile-table a {
    color: #000 !important;
    text-decoration: none !important;
  }

  table.profile-table a:after {
    content: "" !important;
  }

  /* Section titles */
  .text-primary {
    font-size: 14px !important;
    color: #000 !important;
    font-weight: bold !important;
    margin-bottom: 10px !important;
    margin-top: 12px !important;
    border-bottom: 1px solid #000 !important;
    padding-bottom: 5px !important;
  }

  /* Form boxes */
  .reg-form-box {
    page-break-inside: avoid !important;
    margin-bottom: 10px !important;
    width: 100% !important;
    border: none !important;
  }

  .reg-form-body {
    padding: 5px !important;
    width: 100% !important;
    border: none !important;
  }

  /* Page breaks */
  .application-view {
    page-break-after: auto !important;
  }

  /* Ensure content fits on page */
  @page {
    size: A4;
    margin: 10mm 12mm;
  }

  /* Reset any flex layouts */
  .d-flex,
  .flex-row,
  .flex-column {
    display: block !important;
  }

  /* Improve overall spacing */
  .bv-example-row {
    margin: 0 !important;
    width: 100% !important;
  }

  /* Make text more readable on all devices */
  body, td, th, span, p, div {
    font-family: Arial, sans-serif !important;
    font-size: 11px !important;
  }

  /* Ensure borders are visible */
  table, td, th {
    border-color: #000 !important;
  }

  /* Override any viewport-specific styles */
  @viewport {
    width: device-width;
    zoom: 1.0;
  }

  /* Disable zoom and scaling for print */
  meta[name="viewport"] {
    content: "width=device-width, initial-scale=1.0" !important;
  }

  /* Force standard page width regardless of device */
  .application-view {
    width: 100% !important;
    max-width: none !important;
    min-width: 100% !important;
  }

  /* Ensure proper rendering on mobile browsers */
  img {
    max-width: 100% !important;
    height: auto !important;
  }

  .applicant-photo {
    max-width: 110px !important;
    width: 110px !important;
    height: 130px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/ViewPresonalDetailsProfile.vue